<template>
  <div class="polly-splash">
    <svg
      class="polly-splash__logo"
      viewBox="0 0 31 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M2.99497 14.2031V19.8008H0V3.00781H6.99759C11.2801 3.00781 13.7853 4.82705 13.7853 8.18566C13.7853 11.5443 11.2801 13.3635 6.99759 13.3635H3.87667L2.99497 14.2031ZM6.99759 10.6066C9.54471 10.6066 10.7483 9.72501 10.7483 8.22764C10.7483 6.73026 9.48873 5.80665 6.99759 5.80665H2.99497V10.5927L6.99759 10.6066Z"
        fill="#333333"
      />
      <path
        d="M28.3239 0L30.787 1.46939L15.3923 24H11.8516L28.3239 0Z"
        fill="#01FFF0"
      />
    </svg>
    <p class="polly-splash__message">Loading...</p>
  </div>
</template>

<script>
export default {
  name: 'PollySplash',
};
</script>

<style lang="scss">
// Page-load splash matching the NextGen app's boot screen: a bouncing Polly
// "P/" mark over a "Loading..." message.
.polly-splash {
  // Full-viewport overlay so the logo centers on the whole window (ignoring the
  // nav gutter), matching the NextGen app's boot splash.
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: #f4f4f4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &__logo {
    width: 80px;
    height: auto;
    animation: polly-splash-bounce 1s ease-in-out infinite;
  }

  &__message {
    margin: 2rem;
    color: #595959;
    font-size: 1.5rem;
  }
}

@keyframes polly-splash-bounce {
  0%,
  100% {
    transform: translateY(0);
    filter: drop-shadow(4px 6px 4px rgba(0, 0, 0, 0.1));
  }
  50% {
    transform: translateY(8px);
    filter: drop-shadow(8px 10px 8px rgba(0, 0, 0, 0.1));
  }
}
</style>
